import React, { useEffect, useState } from 'react'
import { connect } from "react-redux"
import TopBarNav from '../../common/TopBarNav'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { useHistory } from 'react-router-dom'
import BreadcrumbsHistory from '../../common/BreadcrumbsHistory'
import * as navigationActions from '../../../actions/common/NavigationActions'
import { CollateralStyles } from '../CollateralStyles'
import * as CollateralActions from "../../../actions/collateral/CollateralActions"
import { bindActionCreators } from 'redux'
import { Backdrop, CircularProgress } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import AppBar from "@material-ui/core/AppBar"
import Tab from "@material-ui/core/Tab"
import TabContext from "@material-ui/lab/TabContext"
import TabList from "@material-ui/lab/TabList"
import TabPanel from "@material-ui/lab/TabPanel"
import { makeStyles } from '@material-ui/core/styles'
import Modal from 'antd/es/modal';
//*Components Details
import WorkOrderDetails from './common/WorkOrderDetails'
import Invoice from './common/Invoice'
import Rigths from './common/Rigths'
import Status from './common/Status'

const useStyles = makeStyles({
    appbar: {
        backgroundColor: "White",

    },
    tab: {
        backgroundColor: '#A5A5A5',
        '&.Mui-selected': {
            backgroundColor: '#789AC1'
        },
        borderTopRigthRadius: "15%",
        textTransform: "capitalize"
    },
    indicator: {
        backgroundColor: "#7a9bc2"
    }
})

const CollateralDetailsOnTramit = ({ classes, ...props }) => {
    const { match: { params } } = props;

    const history = useHistory();
    const localclass = useStyles();
    const { t } = useTranslation();

    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [value, setValue] = useState("1")
    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/collateral/WorkOrderDetailsComprobation',
            linkLegend: t('collateralDetails.workOrderDetails'),
            urlParams: [{ key: 'branchOfficeId', value: props.branchOfficeId }, { key: 'wOID', value: params.woid }, "receptionProcess"]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Work_Order_Detail(props.userLanguage, props.userToken, params.branchOfficeId, params.woid, "receptionProcess", onError, onSuccess)
        return () => {

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.alert500')
                    })
                    break
                default:
                    break
            }
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} >
                        <p className={classes.titles}>{t('collateralDashboard.Tramite')}</p>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} >
                        <TabContext value={value}>
                            <AppBar position="static" elevation={0}>
                                <TabList onChange={handleChange} aria-label="simple tabs example" className={localclass.appbar} TabIndicatorProps={{ className: localclass.indicator }}>
                                    <Tab label={t('collateralDetails.workOrderDetails')} value="1" className={localclass.tab} />
                                    <Tab label={t('common.invoice')} value="2" className={localclass.tab} />
                                    <Tab label={t('common.rigths')} value="3" className={localclass.tab} />
                                    <Tab label={t('common.status')} value="4" className={localclass.tab} />
                                </TabList>
                            </AppBar>
                            <TabPanel value="1" className={classes.paddingTabPanel}>
                                {
                                    props.workDetail.length
                                        ? <WorkOrderDetails {...props} />
                                        : <CircularProgress color="inherit" />
                                }
                            </TabPanel>
                            <TabPanel value="2" className={classes.paddingTabPanel}>
                                <Invoice {...props} />
                            </TabPanel>
                            <TabPanel value="3" className={classes.paddingTabPanel}>
                                <Rigths {...props} />
                            </TabPanel>
                            <TabPanel value="4" className={classes.paddingTabPanel}>
                                <Status {...props} />
                            </TabPanel>
                        </TabContext>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    workDetail: state.CollateralReducer.workOrderDetail,
    dashboardItems: state.CollateralReducer.list,
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(CollateralActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(CollateralStyles)(CollateralDetailsOnTramit))
